module.exports = {
    1: 'Contacts List'
}